import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css']
})
export class PublicComponent implements OnInit {

  route:string;
  allIndustriesDetails:any[] = [];
  allCityList = [];
  searchField = {
    "status":"",
    "indCategory":"",
    "district":"",
    "address":"",
    "vendorName":"",
    "industryId":"",
    "industryName":"",
    "emmisionType":"",
    "region":"",
    "categoryType":"",
    "parameter":""
  };

  industryListLoader = false;
  public state: string = environment.state;
  public stateCode: string = environment.stateCode;

  // for public dashboard
  cardDetail = [];
  exceedDetail = [];
  industryCardLoader = false;
  countDuration = 1;
  countFrom = 0;
  userData:any = [];
  userName = null;
  vendor_id = 0;
  userLevel = null;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {

    this.getCityList();
    this.getAllIndustryDetails();

    this.getAllIndustryCardDetails();
    this.getAllIndustryCardExceedanceDetails();

    if(this.state == 'Haryana'){
      Swal('Information!', '<strong>All the vendors are requested to <br/> please email us on hspcbeeit@gmail.com <br/> for the login credentials</strong>', 'info');
    }else{
      // Swal('Information!', '<strong>All the vendors are requested to <br/> please email us on anil.kumar@nic.in <br/> for the login credentials</strong>', 'info');
    }

  }


  getCityList(){

    this.route  = 'get-all-city-list-public';
    let data = {};

    this._service.postRequestNoTokenCreator(data, this.route).subscribe((response: any) => {

      if(response.status == 200){
        this.allCityList = response.data;
      }
    });

  }

  getAllIndustryDetails(){

    this.industryListLoader = true;
    this.route  = 'get-all-industry-details-public';
    this.allIndustriesDetails = [];

    let data = {'search_fields':this.searchField,'type':'public'};

    this._service.postRequestNoTokenCreator(data, this.route).subscribe((response: any) => {

      if(response.status == 200){
        this.allIndustriesDetails = response.data;
        const value = response.data[0].parameter_values
        console.log(typeof value);

        if (typeof value === 'string') {
          this.allIndustriesDetails.forEach( value => {
           value.parameter_values = JSON.parse(value.parameter_values);
           value.parameter_values.forEach(param=> {
             if (param && !isNaN(Number(param.max)) && !isNaN(Number(param.current))) {
               if (Number(param.max) < Number(param.current)) {
                 param.color = '#ff0000'
               } else {
                 param.color = '#2196F3'
               }
             } else {
               param.color = '#2196F3'
             }
           })
          })
          console.log(this.allIndustriesDetails);
        }
      }
      this.industryListLoader = false;
    });
  }




//   For public dashboard

  getAllIndustryCardDetails(){

    this.industryCardLoader = true;
    this.route  = 'get-public-industry-card-details';
    const token    = localStorage.getItem('userToken');
    this.cardDetail = [];
    let data = {};


    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      // if(response.status == 204) {
      //   localStorage.removeItem('userToken');
      //   localStorage.removeItem('userData');
      //   this.router.navigate(['login']);
      //   // location.reload();
      // }
      if(response.status == 200){
        this.cardDetail = response.data;
      }

      this.industryCardLoader = false;
    });
  }

  getAllIndustryCardExceedanceDetails(){

    this.industryCardLoader = true;
    this.exceedDetail = [];
    this.route  = 'get-public-industry-card-exceedance-details';
    const token    = localStorage.getItem('userToken');
    let data = {};

    if(this.userLevel == 'vendor'){
      data = {'user_id':this.userName,'user_level':this.userLevel, 'vendor_id':this.vendor_id};
    }else {
      data = {'user_id':this.userName,'user_level':this.userLevel};
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      this.industryCardLoader = false;
      if(response.status == 200){
        this.exceedDetail = response.data;
      }

    });
  }

}
